import { Box, Button, Theme } from "@outschool/backpack";
import {
  ActivityRatingAndReviewsQuery,
  ClassDetailsQuery_ActivityFragment,
} from "@outschool/gql-frontend-generated";
import { useTranslation } from "@outschool/localization";
import React from "react";

import { PublicReviewQuote } from "./index";

type ReviewsProps = {
  reviews: ActivityRatingAndReviewsQuery["activity"]["recentReviews"];
  leader: ClassDetailsQuery_ActivityFragment["leader"];
  handleShowMoreClick: () => Promise<void>;
  ReviewRespondButton?: React.ElementType;
  reviewsWithTextCount: number;
  recentReviewsCount: number;
  isLeaderReviewsTab?: boolean;
};
export default function Reviews({
  reviews,
  leader,
  handleShowMoreClick,
  ReviewRespondButton,
  reviewsWithTextCount,
  recentReviewsCount,
  isLeaderReviewsTab = false,
}: ReviewsProps) {
  const { t } = useTranslation("ui-components-website\\src\\Reviews\\Reviews");

  const SeeMoreReviewsButton =
    reviewsWithTextCount > recentReviewsCount ? (
      <Box
        flex
        sx={{
          justifyContent: "flexStart",
          paddingTop: "1em",
        }}
      >
        <Button
          onClick={handleShowMoreClick}
          color="neutral"
          sx={{ color: "black" }}
        >{t`See More Reviews`}</Button>
      </Box>
    ) : null;

  return (
    <Box
      flex
      sx={(theme: Theme) => ({
        flexWrap: "wrap",
        width: "100%",
        flexDirection: "row",
        [theme.breakpoints.down("xl")]: {
          flexDirection: "column",
        },
      })}
    >
      {reviews.map((review, idx) => (
        <PublicReviewQuote
          containerSx={(theme: Theme) => ({
            paddingY: "0.5em",
            paddingX: idx % 2 === 0 ? "0 1.5rem" : "1.5rem 0",
            width: "50%",
            [theme.breakpoints.down("xl")]: {
              width: "100%",
              paddingX: 0,
            },
          })}
          reviewSx={(theme: Theme) => ({
            width: "37.1rem",
            padding: "2rem",
            minHeight: "24.4rem",
            borderRadius: "0.8rem",
            height: "100%",
            [theme.breakpoints.down("xl")]: {
              width: "100%",
              minHeight: "17rem",
            },
          })}
          showMoreMaxChars={150}
          teacher={leader}
          activity={review.activity}
          review={review}
          key={review.uid + "/quote"}
          trackingLabel="public_review_of_leader"
          ReviewRespondButton={ReviewRespondButton}
          shouldShowClassLinkBelowReviewdAt={false}
          shouldShowClassLinkBelowStarRating={isLeaderReviewsTab}
        />
      ))}
      {SeeMoreReviewsButton}
    </Box>
  );
}
